import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

const Home = lazy(() => import("./pages/Home"));
const About = lazy(() => import("./pages/About"));
const Product = lazy(() => import("./pages/Product"));
const FireFightingProjects = lazy(() => import("./pages/FireFightingProjects"));
const CivilProjects = lazy(() => import("./pages/CivilProjects"));
const CivilServices = lazy(() => import("./service/CivilServices"));
const FireServices = lazy(() => import("./service/FireServices"));
const CompressedAirSystem = lazy(() => import("./service/CompressedAirSystem"));
const Ventilation = lazy(() => import("./service/Ventilation"));
const Contact = lazy(() => import("./pages/Contact"));
const NoMAtch = lazy(() => import("./pages/404"));

const App = () => {
  return (
    <Router>
      <Suspense fallback={<div />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/product" element={<Product />} />
          <Route path="/civilservices" element={<CivilServices />} />
          <Route path="/fireservices" element={<FireServices />} />
          <Route path="/compressedairsystem" element={<CompressedAirSystem />} />
          <Route path="/ventilation" element={<Ventilation />} />          
          <Route path="/fireFightingProjects" element={<FireFightingProjects />} />          
          <Route path="/civilProjects" element={<CivilProjects/>} />          
          <Route path="/contact-us" element={<Contact />} />
          <Route path="*" element={<NoMAtch />} />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default App;
